var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.movies),function(item,index){return _c('li',{key:index,class:_vm.currentIndex==index?'active':'',on:{"click":function($event){return _vm.btnClick(index)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }